// extracted by mini-css-extract-plugin
export default {"TabPanel":"TabPanel_TabPanel__PPFXg","TabPanelContent":"TabPanel_TabPanelContent__HC8uN","TabPanelContentd":"TabPanel_TabPanelContentd__ahc9I"};